import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card/Card';
import styles from './ErrorBoundary.css';
import { noticeError } from '../../newrelic';

class ErrorBoundary extends React.Component {
    static propTypes = {
        /**
         * If an error occurrs show this msg
         */
        errorMsg: PropTypes.string,
        /**
         * Optional rendering fn to display error
         */
        render: PropTypes.func
    };

    static defaultProps = {
        errorMsg: 'An Error Occurred :(',
        render: (x) => x
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        const msg = this.props.errorMsg;
        noticeError(error, { msg, info });
        // @todo We should have a logging service
        // like sentry or newrelic that
        // we can send these browser errors to.

        // eslint-disable-next-line no-console
        console.error(`${msg}:`, error, info);
    }

    render() {
        const { id } = this.props;
        const cardID = id && id;
        return this.state.hasError ? (
            <Card id={cardID}>
                <div>
                    {this.props.render(this.props.errorMsg)}
                    <style jsx>{styles}</style>
                </div>
            </Card>
        ) : (
            this.props.children
        );
    }
}

export default ErrorBoundary;
